module.exports = __webpack_public_path__ + "static/media/thumbs-up.668b881e.svg";